import deleteMethod from "./method.delete";
import postMethod from "./method.post";
import putMethod from "./method.put";
import getMethod from "./method.get";
import patchMethod from "./method.patch";

const api = {
  deleteMethod,
  postMethod,
  putMethod,
  getMethod,
  patchMethod,
};

export default api;
